import { GetFilterVariantsForVipPageQuery } from '../../graphql/graphql';
import { ItemFilter } from '../../graphql/types';
import { BreadcrumbI } from '../../components/Breadcrumbs';
import { findParamById } from './findParamById';
import { SEARCH_RESULT_ROUTES } from './constants';

export const getBreadcrumbs = (
  filters: GetFilterVariantsForVipPageQuery,
  adaptFilter: ItemFilter,
  pageName = 'search-result'
): { breadcrumbs: BreadcrumbI[]; currAdaptFilter: ItemFilter } => {
  const { categories, cities, type } = filters;
  const categoryId = adaptFilter?.categoryId || null;
  const cityId = adaptFilter.cityId || null;

  const currCategory = findParamById(categories, categoryId);
  const currCity = findParamById(cities, cityId);
  const currType = findParamById(type, adaptFilter.leased);

  const breadcrumbs: BreadcrumbI[] = [];
  let currentPath = '/';
  let currentQuery = '';

  breadcrumbs.push({
    stat: `${pageName}-breadcrumbs-items-all`,
    text: 'main_menu.all_ads',
    link: SEARCH_RESULT_ROUTES.ITEMS_ALL
  });

  currCity.forEach(city => {
    currentPath =
      currentPath === '/' ? `/${city.slug}` : `${currentPath}/${city.slug}`;

    breadcrumbs.push({
      stat: `${pageName}-breadcrumbs-city`,
      text: city.name || '',
      link: currentPath
    });
  });

  currType.forEach(t => {
    const typeSlug = t.name?.toLowerCase();
    currentPath =
      currentPath === '/' ? `/${typeSlug}` : `${currentPath}/${typeSlug}`;

    breadcrumbs.push({
      stat: `${pageName}-breadcrumbs-building-type`,
      text: `main_menu.${adaptFilter.leased ? 'lease' : 'sale'}`,
      link: currentPath
    });
  });

  if (adaptFilter.paidDaily !== undefined) {
    currentQuery = `?paid_daily=${adaptFilter.paidDaily}`;

    breadcrumbs.push({
      stat: `${pageName}-breadcrumbs-lease-term`,
      text: `main_menu.${adaptFilter.paidDaily ? 'paid_daily' : 'long_term_lease'}`,
      link: `${currentPath}${currentQuery}`
    });
  }

  const categoryBasePath = currentPath;

  currCategory.forEach(cat => {
    const categorySlug = cat.slug;

    currentPath =
      categoryBasePath === '/'
        ? `/${categorySlug}`
        : `${categoryBasePath}/${categorySlug}`;

    breadcrumbs.push({
      stat: `${pageName}-breadcrumbs-${cat?.isChild ? 'child-' : 'parent-'}category`,
      text: cat.name,
      link: `${currentPath}${currentQuery}`
    });
  });

  return {
    breadcrumbs,
    currAdaptFilter: { ...adaptFilter, categoryId, cityId }
  };
};
